import { render, staticRenderFns } from "./MessageFormTab.vue?vue&type=template&id=e8e05ec4&scoped=true&lang=pug"
import script from "./MessageFormTab.vue?vue&type=script&lang=ts"
export * from "./MessageFormTab.vue?vue&type=script&lang=ts"
import style0 from "./MessageFormTab.vue?vue&type=style&index=0&id=e8e05ec4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e05ec4",
  null
  
)

export default component.exports